import { getCurrentLocale, getRequest } from '../../utils'
import { TaxRate } from './types/taxRate'
import { TaxRule } from './types/taxRule'

interface FetchSalesVatRatesWithRulesResponseData {
  rules: TaxRule[]
  taxRates: TaxRate[]
}

export const fetchSalesVatRatesWithRules = (
  organizationId: string,
): Promise<FetchSalesVatRatesWithRulesResponseData> => {
  const locale = getCurrentLocale()
  return getRequest(`/v2/bookkeeping/salesVatRatesWithRules?organizationId=${organizationId}`, {
    'Accept-Language': locale,
  })
}
